// material-ui
import Grid from '@mui/material/Grid2';
import Slider from '@mui/material/Slider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';

// project imports
import { ThemeMode } from 'config';
import useConfig from 'hooks/useConfig';
import { LAYOUT_FONT_SIZE_MAX_PX, LAYOUT_FONT_SIZE_MIN_PX } from 'constants/layoutPreferences';

// concat 'px'
function valueText(value) {
  return `${value}px`;
}

const FONT_SIZE_LABEL_ID = 'layout-font-size-slider-label';

export default function FontSize() {
  const { mode, fontSize, onChangeFontSize } = useConfig();

  return (
    <Stack spacing={2.5} id="font-size-id">
      <Typography id={FONT_SIZE_LABEL_ID} sx={{ fontSize: '16px', fontWeight: '500' }} color="grey.800">
        <FormattedMessage id="fontSize" defaultMessage="Font Size" />
      </Typography>
      <Grid sx={{ pt: 4 }}>
        <Grid size="grow" sx={{ height: '40px' }}>
          <Slider
            id="fontSize"
            value={fontSize}
            onChange={onChangeFontSize}
            onChangeCommitted={(event, value) => onChangeFontSize(event, value, { persist: true })}
            getAriaValueText={valueText}
            valueLabelDisplay="on"
            aria-labelledby={FONT_SIZE_LABEL_ID}
            min={LAYOUT_FONT_SIZE_MIN_PX}
            max={LAYOUT_FONT_SIZE_MAX_PX}
            sx={{
              '& .MuiSlider-thumb': {
                backgroundColor: '#009688'
              },
              '& .MuiSlider-track': {
                backgroundColor: '#009688',
                borderColor: '#009688'
              },
              '& .MuiSlider-rail': {
                backgroundColor: mode === ThemeMode.DARK ? 'grey.600' : 'grey.300'
              },
              '& .MuiSlider-valueLabel': {
                color: '#000',
                fontSize: '14px',
                backgroundColor: '#A7EFD8'
              }
            }}
          />
        </Grid>
        <Grid size={12} sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography sx={{ fontSize: '14px', color: 'grey.700' }}>{LAYOUT_FONT_SIZE_MIN_PX}px</Typography>
          <Typography sx={{ fontSize: '14px', color: 'grey.700' }}>{LAYOUT_FONT_SIZE_MAX_PX}px</Typography>
        </Grid>
      </Grid>
    </Stack>
  );
}
